import { call, put } from 'redux-saga/effects';
import api from '../../../../api-new/http';
import { signInData, signInError, SignInFetch } from '../actions';
import { appUrls } from '../../../../api-new/urls';
import { sendError } from '../../../public/errorHandler';
import { userData } from '../../profile';

import { SagaIterator } from 'redux-saga';

export function* signInSaga(action: SignInFetch): SagaIterator {
    try {
        const response = yield call(() => api.post(`${appUrls.authenURL}/login`, action.payload, {
            headers: {
                'Content-Type': 'application/json',
            },
            // withCredentials: true
        }));
        const { accessToken, refreshToken } = response.data.data;
        localStorage.setItem('csrfToken', accessToken);
        localStorage.setItem('themeCode', refreshToken);
        const responseProfile = yield call(() => api.get(`${appUrls.authenURL}/profile`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        }));

        (window as any).umami?.track('login', { method: 'standard', email: responseProfile.data.data.email });

        yield put(userData({ user: responseProfile.data.data }));
        yield put(signInData());
    } catch (error: any) {
        const errorSetup = {
            message: error.response.data.errors[0].errorMessage,
            code: error.response.status,
            codeConfig: error.response.data.errors[0].errorCode,
        };
        yield put(
            sendError({
                error: errorSetup,
                processingType: 'alert',
                extraOptions: {
                    actionError: signInError,
                },
            }),
        );
    }
}
